import {parse, ParseResult} from 'papaparse';
import {
    GET_RECORDS_REQUIRED_COLUMNS,
    UPDATE_RECORDS_REQUIRED_COLUMNS
} from "src/constants/program-source";

type GetRecordsColumns = typeof GET_RECORDS_REQUIRED_COLUMNS[number];
type UpdateRecordsColumns = typeof UPDATE_RECORDS_REQUIRED_COLUMNS[number];
type RequiredColumns = GetRecordsColumns | UpdateRecordsColumns;

interface ParseCSVOptions {
    maxRows: number;
    requiredColumns?: readonly RequiredColumns[];
    forbiddenColumns?: readonly string[];
}

export const parseCSVFile = async (file: Blob, options: ParseCSVOptions): Promise<ParseResult<any>> => {
    return new Promise((resolve, reject) => {
        parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (result) => {
                if (result.data.length === 0) {
                    reject(new Error("CSV File should have at least one row"));
                    return;
                }

                if (result.data.length >= options.maxRows + 1) {
                    reject(new Error(`Max ${options.maxRows} rows allowed`));
                    return;
                }

                if (options.requiredColumns) {
                    const missingColumns = options.requiredColumns.filter(
                        col => !result.meta.fields?.includes(col)
                    );
                    if (missingColumns.length > 0) {
                        reject(new Error(`Missing required columns: ${missingColumns.join(', ')}`));
                        return;
                    }
                }

                if (options.forbiddenColumns) {
                    const foundForbiddenColumns = options.forbiddenColumns.filter(
                        col => result.meta.fields?.includes(col)
                    );
                    if (foundForbiddenColumns.length > 0) {
                        reject(new Error(`CSV file cannot contain columns: ${foundForbiddenColumns.join(', ')}`));
                        return;
                    }
                }
                resolve(result);
            },
            error: reject,
        });
    });
};